export const getProgressBarItemFillerWidth = (prev = 0, totalAmount, step) => {
	return totalAmount >= step
		? '100%'
		: totalAmount > prev
			? `${(totalAmount / step) * 100}%`
			: 0;
};
